<template>
  <div class="LoaderPanelComponent" role="status" aria-live="polite" :aria-label="ARIA_LABELS.LOADING">
    <div class="loader-header">
      <HeaderComponent v-if="loadHeader && !isDialogOpen()" />
    </div>
    <div :class="loaderWrapperClasses">
      <div
        v-if="icon"
        class="icon-wrapper"
      >
        <i :class="icon" />
      </div>

      <p
        v-for="(text, i) in overLoaderTexts"
        :key="i"
        class="over-loader-text"
      >
        {{ text }}
      </p>

      <LoaderComponent />

      <p
        v-for="(text, i) in texts"
        :key="i"
      >
        {{ text }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import LoaderComponent from '@/modules/core/components/loading/LoaderComponent.vue'
import { computed } from 'vue'
import { HeaderComponent } from '@/modules/core/components'
import { ARIA_LABELS } from '@/modules/core/constants/ariaLabels'

interface PropsInterface {
  loadHeader: boolean
  texts?: string[] | null
  overLoaderTexts?: string[] | null
  icon?: string
}
withDefaults(defineProps<PropsInterface>(), {
  texts: () => []
})

const isDialogOpen = () => {
  return !!document.querySelector('.v-overlay-container')?.innerHTML
}

const loaderWrapperClasses = computed(() => ({
  LoaderWrapper: true,
  'loader-under-header': !isDialogOpen()
}))
</script>

<style lang="scss" scoped>
.LoaderPanelComponent {
  position: fixed;
  overflow: auto;
  inset: 0;
  width: $size-screen-w;
  height: $size-screen-h;
  background: rgb(255 255 255 / 100%);
  z-index: $z-index-loader;

  .loader-header {
    width: $size-full;
    max-width: $size-1440;
    margin: 0 auto;
  }

  .loader-under-header {
    .LoaderComponent,
    p,
    .icon-wrapper {
      transform: translate(0, -80px);
    }
  }

  .LoaderWrapper {
    width: $size-full;
    height: $size-full;
    padding: 0 $spacing-l;
    display: grid;
    place-items: center;
    place-content: center;

    // gap: $gap-xl;
    p {
      font-family: $font-family-primary;
      font-size: $font-size-2xl;
      font-style: normal;
      font-weight: $font-weight-700;
      line-height: $line-height-130p;
      color: $color-primary-dark;
      text-align: center;
    }

    .LoaderComponent {
      @include gl-mx-animation-fade-in;
    }

    .icon-wrapper {
      text-align: center;

      i {
        font-size: $font-size-80;
      }
    }

    .over-loader-text:first-of-type {
      margin-top: $spacing-55;
    }

    .over-loader-text:last-of-type {
      margin-bottom: $spacing-85;
    }
  }
}
</style>
